import { useCallback } from "react";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { useAlbums } from "@hooks/trpc/useAlbums";
import { useShare } from "@hooks/trpc/useShare";

const AlbumButtons = ({
  id,
  type,
  iconSize,
}: {
  id: string;
  type: "album";
  iconSize: number;
}) => {
  const {
    query: { data: albumsData },
  } = useAlbums(type === "album" && id ? [id] : undefined);
  const share = useShare();

  const handlePressShare = useCallback(() => {
    const album = albumsData?.at(0);
    if (!album) return;
    const directLink = {
      contentType: "album" as const,
      data: {
        id: album.id,
        title: album.title,
        artistDisplayText: album.artistDisplayText,
        imageUrl: album.image ?? null,
      },
    };

    share.mutate({
      linkType: "direct-link",
      ...directLink,
    });
  }, [albumsData, share]);

  return (
    <>
      <LPressable
        sentryEventName="share_collection"
        onPress={handlePressShare}
        disabled={share.isPending}
        style={{ opacity: share.isPending ? 0.5 : 1 }}
      >
        <LIcon name="share" size={iconSize} />
      </LPressable>
    </>
  );
};

export default AlbumButtons;
